<footer>
  <span flexLayout="column" flexLayoutAlign="start center" class="menu-item copyright">
    {{ appCopyright ? appCopyright : uiDisplayTagService.displayTags.copyrightNav }}
  </span>
</footer>
